<label class="floatingLabel secondary">
	<mat-icon [fontIcon]="icon()" fontSet="fad" inline />
	{{ label() | translate }}
</label>
<div class="contentWrapper">
	<ng-content />
</div>
